/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />
/// <reference path="app.hilo.module.ts" />


/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />
/// <reference path="../common/routesbase.ts" />

module App.HiLO {
    'use strict';

    class HiLORoutes extends Common.RoutesBase {

        public static $inject = ['$stateProvider'];

        constructor($stateProvider: angular.ui.IStateProvider) {
            super($stateProvider);

            this.templateDir = 'HiLO';

            this.addState('Home', { url: '/', mainUrl: 'Templates/HiLO/HomeView.html' });
            this.addState('SellLease');
            this.addState('ApplyWorks');
            this.addState('ReleaseCharge');
            this.addState('SubmissionComplete', { url: '/SubmissionComplete/:id/:product' });
            this.addState('PredecessorOrganisations', { url: '/PredecessorOrganisations', mainUrl: 'Templates/HiLO/PredecessorOrganisationsView.html' });
            this.addState('Support');

         //   this.addState('UploadTest');

        }

    }

    angular
        .module('app.hilo')
        .config([
            '$stateProvider', ($stateProvider: angular.ui.IStateProvider) => {
                return new HiLORoutes($stateProvider);
            }
        ]);

}